/* tslint:disable */
/* eslint-disable */
export enum JofiExpectedDegreeEnum {
  EnumsJofiExpectedDegreeBezGymP = 'enums.jofiExpectedDegree.bezGymP',
  EnumsJofiExpectedDegreeSekE = 'enums.jofiExpectedDegree.sekE',
  EnumsJofiExpectedDegreeRealSekA = 'enums.jofiExpectedDegree.realSekA',
  EnumsJofiExpectedDegreeKleinSonder = 'enums.jofiExpectedDegree.kleinSonder'
}
